import AddressDeleteModal from './address-delete-modal-view'

export default AddressDeleteModal
